import { gql } from '@apollo/client';

export const ARCHIVE_INSTITUTION_FROM_INSTITUTION_PORTAL = gql`
  mutation ArchiveInstitutionFromInstitutionPortal($id: ID!) {
    institution: archiveInstitutionFromInstitutionPortal(id: $id) {
      id
      name
    }
  }
`;
